import * as React from 'react';
import { OnboardingTooltip } from '@cian/ui-kit';

import { CompareOnboardingContent } from './CompareOnboardingContent';
import * as styles from './NewbuildingCompareButton.css';

interface ICompareButtonOnboardingProps extends React.PropsWithChildren {
  open: boolean;
  onClose(): void;
}

export function CompareButtonOnboarding({ children, open, onClose }: ICompareButtonOnboardingProps) {
  return (
    <OnboardingTooltip
      theme="blue"
      content={<CompareOnboardingContent />}
      placement="left"
      portal={false}
      open={open}
      onClose={onClose}
      flip={false}
    >
      <div className={styles['onboarding-anchor']}>{children}</div>
    </OnboardingTooltip>
  );
}
